import React, { useState,useEffect,useMemo }  from "react";
import { Table, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { updateUI } from "../../../store/actions/shipment";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { removeAccountPrefixFromLabels } from "../../../../src/global/utility/Utils";

function BLEDetails() {
  const dispatch = useDispatch();
  const [selectedDevices, setSelectedDevices] = useState({});
  const { selectedProfile } = useSelector((state) => ({
    selectedProfile: state.shipment.ui.clone.editField.profile.value,
  }));
  const deviceName = useSelector((state) => state?.shipment?.data?.deviceName); 
  const shipmetProfile = useSelector((state) => state?.shipment?.data?.shipProfile);
  const ble = useSelector((state) => state?.shipment?.ui.clone?.ble);
  const bleProfile = useSelector((state) => state?.shipment?.ui?.clone?.bleProfile); 

  const tableprofileData =deviceName?.devices; 
  const filteredDevices = tableprofileData;
  let tableData = [];
  var value= filteredDevices
  var shipmetProfileVal = shipmetProfile;

  useEffect(() => {
    let initialDevices = {};
    let initialProfiles = {};
    ble?.forEach(item => {
        initialDevices[item.uid] = true;
        initialProfiles[item.uid] = item.deviceProfile;
    });
    setSelectedDevices(initialDevices);
    if (ble?.length > 0 && (ble[0]?.deviceProfile === "" || ble[0]?.deviceProfile === undefined)) {
      dispatch(updateUI({
        key: "clone",
        value: {
          bleProfile: "",
        },
      }))
    }
}, [ble, dispatch]);

const handleCheckboxChange = (uid, devicemodel) => {
  setSelectedDevices(prev => {
      const updatedSelection = { ...prev, [uid]: !prev[uid] };
      if (!updatedSelection[uid]) {
        dispatch(updateUI({
          key: "clone",
          value: {
            ble: (ble || []).filter(item => item.uid !== uid) 
          },
      }));
      } else {
        dispatch(updateUI({
          key: "clone",
          value: {
            ble: [...(ble || []), { uid, devicemodel, deviceProfile: "" }] 
          },
      }));
      
      }
      return updatedSelection;
  });
};
function getDeviceDetails(devices, deviceProfile) {
  let result = devices?.find(device => device?.profileid === deviceProfile);
  if (result) {
    return {
      attributes: result?.attributes || [],
      name: result?.profilename || "BLE Device Profile",
    };
  }
  return { attributes: [], name: "BLE Device Profile" };
}

const handleChange1 = (e, uid) => {
  const { name, value, id,serial } = e.target;
  if (name === "deviceProfile") {
    let extractedDetails = getDeviceDetails(shipmetProfile, value);
    let attributes = extractedDetails?.attributes;

    dispatch(updateUI({
      key: "clone",
      value: {
        ble: [
          ...ble?.filter(item => item?.uid !== uid),
          { uid, name: id, [name]: value,serial:serial }
        ]
      },
    }));

    dispatch(updateUI({
      key: "clone",
      value: { bleProfile: attributes },
    }));
  }
};

      {value?.filter((item) => item?.kind === "ts.device.ble" && item?.customdata?.isAvailable===true).map((item, index) => (
        tableData.push({ 
            bledeviceid: (
            <li>
            <label>
                <input
                    type="checkbox"
                    className="ble-checkbox"
                    id="rememberMe"
                    checked={selectedDevices[item.uid] || false}
                    onChange={() => handleCheckboxChange(item?.uid, item?.devicetype)}
                      />
                {item?.minor ?? item?.serial}
              </label>
                </li>
            ),
            devicename: item?.name,
            devicemodel: item?.devicetype,
            deviceProfile: (
                <Select
                disabled={!selectedDevices[item.uid]}
               className={`selectboxstyle shipment-clone-fields ${
                selectedDevices[item.uid] && !ble.find(i => i.uid === item.uid)?.deviceProfile
                  ? "selectbox-error"
                  : ble.find(i => i.uid === item.uid)?.deviceProfile
                    ? "selectbox-success"
                    : ""
              }`}
                name="deviceProfile"
                placeholder="Select Device Profile"
                onChange={(value) => handleChange1({ target: { name: "deviceProfile",id:item?.name, value,serial:item?.serial } }, item.uid)}
                value={ble?.find(i => i.uid === item.uid)?.deviceProfile || ""}  
                options={[
                    { value: "", label: "Select Device Profile" },
                    ...(shipmetProfileVal
                        ?.filter((profileItem) => item?.devicetype === profileItem.devicetype && profileItem?.profiletype !=="nonshipment")
                        .map((profileItem) => ({
                          value: profileItem?.profileid,
                            label: profileItem.profilename,
                        })) || []),
                ]}
            />

            ),
        })
    ))}
  const columns = [
    {
      title: <span className="font-face-vzw">BLE device ID</span>,
      dataIndex: "bledeviceid",
      key: "bledeviceid",
      width: 150,
      onHeaderCell: () => ({
        "data-tooltip": "",
      }),
      render: (text) => {
        return text;
      },
    },
    {
      title: <span className="font-face-vzw">Device name</span>,
      dataIndex: "devicename",
      key: "devicename",
    },
    {
      title: <span className="font-face-vzw">Model</span>,
      dataIndex: "devicemodel",
      render: (text) => <span>{text}</span>,
      key: "devicemodel",
    },
    {
      title: <span className="font-face-vzw">Device profile</span>,
      dataIndex: "deviceProfile",
      key: "deviceProfile",
      render: (text) => {
        return text;
      },
    },
  ];
  let tableLocationData = [];
  var value=bleProfile;
  if (Array.isArray(value)) {
    value.forEach((item) => {
      tableLocationData?.push({
        name: `${item?.name} (${item?.unit})`, 
        minAlert: item?.min,
        maxAlert: item?.max,
        alertType: item?.alertType,
        alertGroup: Array.isArray(item?.alertGroup) && item.alertGroup.length > 0
                    ? removeAccountPrefixFromLabels(item.alertGroup).join(", ")
                    : (item?.alertGroup ?? "").toString().trim().length > 0
                      ? removeAccountPrefixFromLabels([item.alertGroup]).join(", ")
                      : "None",
       // alertGroup: item?.alertGroup,
      });
    });
  }

  return (
    <div className="py-3 shipment-clone-step2-container">
      <div
        className="font-face-vzw"
        style={{
          fontWeight: 700,
          fontSize: "20px",
          marginBottom:"2%"
        }}
      >
        BLE Details
      </div>
      <Table dataSource={tableData} columns={columns} pagination={false} locale={{ emptyText: "None of the BLE's are available" }}/>
      {ble[0]?.deviceProfile===''|| ble[0]?.deviceProfile===undefined?
      <Grid2 item xs={12} sm={12} md={12} lg={12}>
                <div className="shipment-profile-info">
                Select a profile to show profile summary
             </div>
             </Grid2>
             : 
             <div>
             <br/>
             <h6 className="model-inline-heading">BLE device profile</h6>
             <br/>
        <div style={{ maxHeight: "400px", overflowY: "auto", width: "100%" }}>
        {ble
        .filter(device => device.deviceProfile)
        .map((device, index) => {
          const extractedDetails = getDeviceDetails(shipmetProfile, device.deviceProfile);
          const attributes = extractedDetails?.attributes || [];

          let tableLocationData = attributes.map(item => ({
            name: `${item?.name} (${item?.unit})`,
            minAlert: item?.min,
            maxAlert: item?.max,
            alertType: item?.alertType,
             alertGroup: Array.isArray(item?.alertGroup) && item.alertGroup.length > 0
                    ? removeAccountPrefixFromLabels(item.alertGroup).join(", ")
                    : (item?.alertGroup ?? "").toString().trim().length > 0
                      ? removeAccountPrefixFromLabels([item.alertGroup]).join(", ")
                      : "None",
           // alertGroup: item?.alertGroup,
          }));

          return (
            <div key={device.uid}>
              <br />
              <h6 className="model-inline-heading">
                {extractedDetails.name}
              </h6>
              <br />
              <div style={{ maxHeight: "400px", overflowY: "auto", width: "100%" }}>
                <Table
                  className="custom-table-shipment"
                  rowKey={`shipment-row-key-${index}`}
                  columns={[
                    { title: "Attribute", dataIndex: "name", key: "name" },
                    { title: "Minimum", dataIndex: "minAlert", key: "minAlert" },
                    { title: "Maximum", dataIndex: "maxAlert", key: "maxAlert" },
                    { title: "Alert Type", dataIndex: "alertType", key: "alertType" },
                    { title: "Alert Group", dataIndex: "alertGroup", key: "alertGroup" },
                  ]}
                  dataSource={tableLocationData}
                  pagination={false}
                />
              </div>
            </div>
          );
        })}
        </div>
    </div>
    }
    </div>
  );
}

export default BLEDetails;
